// Module
var code = "<h2 id=\"ways-to-pay\">Ways to Pay</h2> <p>Learn more about your bill payment options.</p> ";
// Exports
export default code;